import { baseApi } from './baseApi';
import pythonApiClient from './pythonBaseApi';

export const reporteApi = {
  // === REPORTES COMENSALES POR COMEDOR (FastAPI /api-campamento) ===
  descargarReporteComensalesComedorExcel: (params) => {
    return pythonApiClient.get('/reportes/comensales-comedor/excel', {
      params,
      responseType: 'blob',
    });
  },

  generarReporteComensalesComedor: (params) => {
    return pythonApiClient.get('/reportes/comensales-comedor', { params });
  },

  // === REPORTES ATENCIÓN POR COMEDOR (FastAPI /api-campamento) ===
  generarReporteAtencionPorComedor: (params) => {
    return pythonApiClient.get('/reportes/atencion/atencion-por-comedor', { params });
  },

  descargarReporteAtencionPorComedorExcel: (params) => {
    return pythonApiClient.get('/reportes/atencion/atencion-por-comedor/excel', {
      params,
      responseType: 'blob'
    });
  },

  // === CONSULTA ATENCIONES COMENSALES (FastAPI /api-campamento) ===
  buscarComensalParaConsulta: (numeroDocumento) => {
    return pythonApiClient.get('/reportes/consulta-atenciones/buscar-comensal', {
      params: { numero_documento: numeroDocumento }
    });
  },

  obtenerAtencionesComensal: (comensalId, page = 1, perPage = 10) => {
    return pythonApiClient.get('/reportes/consulta-atenciones/obtener-atenciones', {
      params: { 
        comensal_id: comensalId,
        page: page,
        per_page: perPage
      }
    });
  },

  descargarExcelAtencionesComensal: (comensalId) => {
    return pythonApiClient.get('/reportes/consulta-atenciones/excel', {
      params: { comensal_id: comensalId },
      responseType: 'blob'
    });
  },

  // === SISTEMA OFFLINE/CONTINGENCIA ===
  // Generar Excel offline para contingencia
  generarExcelOfflineContingencia: (params) => {
    return pythonApiClient.get('/procesos/sistema-offline/contingencia', {
      params,
      responseType: 'blob'
    });
  },

  // Obtener template para sistema offline
  obtenerTemplateOffline: (params) => {
    return pythonApiClient.get('/procesos/sistema-offline/template', {
      params,
      responseType: 'blob'
    });
  },

  // Procesar datos offline
  procesarDatosOffline: (formData) => {
    return pythonApiClient.post('/procesos/sistema-offline/procesar-datos', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // Validar archivo offline antes del procesamiento
  validarArchivoOffline: (formData) => {
    return pythonApiClient.post('/procesos/sistema-offline/validar-archivo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // === REPORTES CONSOLIDADOS — Laravel (reporte actual, sin cambiar) ===
  generarReporteConsolidadoConsumosComensal: (params) => {
    return baseApi.get('/reportes/consolidado-consumos-comensal', { params });
  },

  descargarReporteConsolidadoConsumosComensal: (params) => {
    return baseApi.get('/reportes/consolidado-consumos-comensal/excel', {
      params,
      responseType: 'blob',
    });
  },

  // === Mismo tipo de reporte vía FastAPI (opción nueva, independiente) ===
  generarReporteConsolidadoConsumosComensalCampamento: (params) => {
    return pythonApiClient.get('/reportes/consumos/consolidado-consumos-comensal', { params });
  },

  descargarReporteConsolidadoConsumosComensalCampamento: (params) => {
    return pythonApiClient.get('/reportes/consumos/consolidado-consumos-comensal/excel', {
      params,
      responseType: 'blob',
    });
  },

  // Reporte consolidado consumos por fechas (JSON)
  generarReporteConsolidadoConsumosFechas: (params) => {
    return baseApi.get('/reportes/consolidado-consumos-fechas', { params });
  },

  // Descargar reporte consolidado consumos por fechas en Excel
  descargarReporteConsolidadoConsumosFechasExcel: (params) => {
    return baseApi.get('/reportes/consolidado-consumos-fechas/excel', {
      params,
      responseType: 'blob'
    });
  },

  // Descargar reporte consolidado de consumos por fechas en Excel
  reporteConsolidadoConsumosPorFechasExcel: async (params) => {
    try {
      const response = await baseApi.get('/reportes/consolidado-consumos-fechas/excel', { 
        params,
        responseType: 'blob'
      });

      // Crear URL para descargar el archivo
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Generar nombre del archivo con fecha actual
      const fechaActual = new Date().toISOString().split('T')[0];
      const nombreArchivo = `consolidado_consumos_fechas_${fechaActual}.xlsx`;
      
      link.setAttribute('download', nombreArchivo);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error('Error descargando reporte:', error);
      throw error;
    }
  },

  // === REPORTES COMENSALES CON DIETAS (FastAPI /api-campamento) ===
  obtenerDatosComensalesDietas: (params) => {
    return pythonApiClient.get('/reportes/comensales-dietas/datos', { params });
  },

  obtenerClientesComensalesDietas: () => {
    return pythonApiClient.get('/reportes/comensales-dietas/clientes');
  },

  obtenerEstadisticasComensalesDietas: (params) => {
    return pythonApiClient.get('/reportes/comensales-dietas/estadisticas', { params });
  },

  descargarComensalesDietasExcel: (params) => {
    return pythonApiClient.get('/reportes/comensales-dietas/excel', {
      params,
      responseType: 'blob'
    });
  },

  // === COMENSALES DUPLICADOS (FastAPI) — consulta por proyecto ===
  obtenerComensalesDuplicados: () => {
    return pythonApiClient.get('/reportes/comensales-duplicados/datos');
  },

  descargarComensalesDuplicadosExcel: () => {
    return pythonApiClient.get('/reportes/comensales-duplicados/excel', {
      responseType: 'blob',
    });
  },

  obtenerAtencionesComensalDuplicadosProyecto: (comensalId) => {
    return pythonApiClient.get('/reportes/comensales-duplicados/atenciones', {
      params: { comensal_id: comensalId },
    });
  },

  obtenerGruposDuplicadosClienteDni: (params = {}) => {
    return pythonApiClient.get('/reportes/comensales-duplicados/grupos-cliente-dni', {
      params,
    });
  },

  obtenerGruposDuplicadosClasificados: (params = {}) => {
    return pythonApiClient.get('/reportes/comensales-duplicados/grupos-clasificados', {
      params,
    });
  },

  consolidarComensalesDuplicados: (payload) => {
    return pythonApiClient.post('/reportes/comensales-duplicados/consolidar', payload);
  },

  listarServiciosDuplicadosComensales: (params = {}) => {
    return pythonApiClient.get('/reportes/alimentacion/servicios-duplicados-comensales', {
      params,
    });
  },

  descargarServiciosDuplicadosComensalesExcel: (params = {}) => {
    return pythonApiClient.get(
      '/reportes/alimentacion/servicios-duplicados-comensales/excel',
      { params, responseType: 'blob' }
    );
  },
};